import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'recaudacion/razon-de-cancelacion-de-infraccion';

/**
 * GET Tipos de Infracciones
 * @returns {Promise<Array<object>>}
 */
export const getRazonesInfracciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de infraccion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getRazoninfraccion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de infraccion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postRazoninfraccion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de  infraccion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchRazoninfraccion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de infraccion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteRazoninfraccion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
